"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CodeArea = void 0;
var tslib_1 = require("tslib");
// (C) 2022 GoodData Corporation
var react_1 = tslib_1.__importStar(require("react"));
/**
 * @internal
 */
exports.CodeArea = function (props) {
    var code = props.code, onCopyCode = props.onCopyCode;
    var onAreaCopyCode = react_1.useCallback(function () {
        onCopyCode(code);
    }, [code]);
    return (react_1.default.createElement("div", { className: "embed-insight-dialog-code-content" },
        react_1.default.createElement("textarea", { className: "embed-insight-dialog-code-area s-code-content", readOnly: true, value: code, onCopy: onAreaCopyCode })));
};
//# sourceMappingURL=CodeArea.js.map